import api from "./index"

export default {
  post: (json) => {
    return api.post('interessenten/', json)
  },
  getAdressmeldung: (adressmeldungId) =>{
    return api.get(`interessenten/?id=${adressmeldungId}`);
  }
}
